import Laurel101 from '../../../Media/BSD/Navapark/Laurel 10.webp'
import Laurel102 from '../../../Media/BSD/Navapark/Laurel 10.webp'





const Laurel10images =[
Laurel101,Laurel102
]

export default Laurel10images;